import { Controller } from "@hotwired/stimulus"

// Sign-in outline glyphs (devise/sessions/new): they hang above the headline, which is centred, so on shorter screens
// they reached under the status bar. Shift them down just enough to clear the top inset (the content column's
// padding-top); where there is room they keep their designed spot. Re-placed on resize.
export default class extends Controller {
  connect() {
    this.content = this.element.closest(".signin-content")
    this.place = this.place.bind(this)
    this.place()
    this.observer = new ResizeObserver(this.place)
    this.observer.observe(this.content || document.documentElement)
    document.fonts?.ready.then(this.place)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  place() {
    if (!this.content) return
    const insetTop = parseFloat(getComputedStyle(this.content).paddingTop) || 0
    this.element.style.translate = ""
    const shift = Math.max(0, Math.ceil(insetTop - this.element.getBoundingClientRect().top))
    if (shift) this.element.style.translate = `0 ${shift}px`
  }
}
